import {getMarketConfig} from "@atg-shared/market-config";

const getMarketHeaders = () => {
    const {brand, market} = getMarketConfig();
    return {
        "X-License": market,
        "X-Brand": brand,
    };
};

export const MarketUtils = {getMarketHeaders};
